import { useMemo } from 'react';

import {
  useIsAskMeAnythingEnabled,
  useIsCalendarInvitationEnabled,
  useIsOnlineMeetingEnabled,
  useIsQuestionsOnlyMode,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventEditingPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventEditingPage'> = (
  options
) => {
  const askMeAnythingEventEditingPageOverrides = options?.overrides?.askMeAnythingEventEditingPage;

  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isCalendarInvitationToggleEnabled = useIsCalendarInvitationEnabled();
  const isOnlineMeetingToggleEnabled = useIsOnlineMeetingEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        calendarInvitationToggleEnabled: isCalendarInvitationToggleEnabled,
        onlineMeetingToggleEnabled: isOnlineMeetingToggleEnabled,
        ...askMeAnythingEventEditingPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMAEnabled,
      calendarInvitationToggleEnabled: isCalendarInvitationToggleEnabled,
      onlineMeetingToggleEnabled: isOnlineMeetingToggleEnabled,
      ...askMeAnythingEventEditingPageOverrides,
    };
  }, [
    askMeAnythingEventEditingPageOverrides,
    isAMAEnabled,
    isQuestionsOnlyMode,
    isCalendarInvitationToggleEnabled,
    isOnlineMeetingToggleEnabled,
  ]);
};
